
import { Model } from './_model';
import SecurityInfo from './securityInfo';
import Participant from './issueParticipant';

export default class Listing extends Model {
  get defaults() {
    return {
      securityType: '',
      securityForm: '',
      mannerOfDistrib: '',
      numberOfSecurity: '',
      securityList: [],
      offerPeriodFrom: '',
      offerPeriodTo: '',
      yearBasis: '',
      wtpeiRemittanceConvention: '',
      dayCountConvention: '',
      denomination: {
        primary: {
          minimum: '',
          increments: ''
        },
        secondary: {
          minimum: '',
          increments: ''
        }
      },
      principalRepaymentSched: '',
      amortizationSched: '',
      preterminationProvisionDescription: '',
      transferOfSecurityRestrictions: '',
      ownershipLimit: {
        type: '',
        percentage: ''
      },
      tax: {
        applicable: '',
        percentage: ''
      },
      participantList: [ new Participant({
        id: '',
        role: 'RegistrarPayingAgent',
        institutionName: 'PHILIPPINE DEPOSITORY & TRUST CORP.',
        allocation: [],
        primaryContact: {
          lastName: 'Garcia',
          firstName: 'Patricia Camille',
          middleInitial: 'R'
        },
        preferredSalutation: 'Ms.',
        title: 'Registry Officer',
        address: {
          street: '29th Floor, BDO Equitable Tower, 8751 Peseo de Roxas',
          city: 'Makati',
          zipCode: '1226'
        },
        telephoneNumber: '8884-4413',
        emailAddress: 'peachy.garcia@pds.com.ph',
        save: true,
        edit: false
      })],
      securityClass: 'SCRIPLESS',
      administerStatus: '0',
      isPublished: false,
      save: 'DRAFT'
    }
  }

  get offerPeriod() {
    return {
      offerPeriodFrom: this.offerPeriodFrom,
      offerPeriodTo: this.offerPeriodTo
    }
  }

  get securityTypeAndForm() {
    return {
      securityType: this.securityType,
      securityForm: this.securityForm,
      securityClass: this.securityClass,
      mannerOfDistrib: this.mannerOfDistrib,
      numberOfSecurity: this.numberOfSecurity,
      isPublished: this.isPublished
    }
  }

  get securityInformation2() {
    return {
      securityType: this.securityType,
      yearBasis: this.yearBasis,
      wtpeiRemittanceConvention: this.wtpeiRemittanceConvention,
      dayCountConvention: this.dayCountConvention,
      denomination: this.denomination,
      principalRepaymentSched: this.principalRepaymentSched,
      amortizationSched: this.amortizationSched
    }
  }

  get securityInformation3() {
    return {
      preterminationProvisionDescription: this.preterminationProvisionDescription,
      transferOfSecurityRestrictions: this.transferOfSecurityRestrictions,
      ownershipLimit: this.ownershipLimit,
      tax: this.tax
    }
  }


}



